// extracted by mini-css-extract-plugin
export var address = "contactD-module--address--04zLe";
export var baton = "contactD-module--baton--WXAVc";
export var different = "contactD-module--different--XbVoq";
export var gap = "contactD-module--gap--r3fnR";
export var group = "contactD-module--group--wh19d";
export var icons = "contactD-module--icons--MrvZB";
export var left = "contactD-module--left--Y1-PM";
export var link = "contactD-module--link--YlJIF";
export var right = "contactD-module--right--FG4sR";
export var special = "contactD-module--special--yon1q";
export var wrapper = "contactD-module--wrapper--ID1yH";